// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"A--z","narrowOptionButtons":"B--z","noOptions":"C--z"};